import React from 'react';

import { BD100HeroContent, BD100HeroDescription, BD100HeroTitle, BD100HeroWrapper } from './styled';

export default function BD100Hero() {
  return (
    <BD100HeroWrapper>
      <BD100HeroContent>
        <BD100HeroTitle>BD 100</BD100HeroTitle>
        <BD100HeroDescription>
          A space for 100 business development leaders across kyu to collaborate and drive growth.
        </BD100HeroDescription>
      </BD100HeroContent>
    </BD100HeroWrapper>
  );
}
